<template>
  <section class="content-element shape">
    <div class="content-element-banner">
      <div class="content-element-banner-image" :style="{
                    backgroundImage: `url('${ image }')`,
                }">
        <div class="content-element-banner-text container">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>
    <div class="content-element-btn">
      <button class="btn btn-more" @click="scrollToElement()">Saber mais
        <svg xmlns="http://www.w3.org/2000/svg" width="24.401" height="24.401" viewBox="0 0 24.401 24.401">
          <path id="Union_1" data-name="Union 1" d="M14.776,0H15.7V14.809h-.924V.871H0V0Z" transform="translate(22.987 11.886) rotate(135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
      </button>
    </div>
  </section>
</template>
<style lang="scss">
.content-element{
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    position: relative;
    &-banner{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      &-image{
        height: 75%;
        width: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: top center;
        @media screen and (max-width: 1199px) {
          height: 73%;
        }
        @media screen and (max-width: 992px) {
          height: 73%;
          background-size: cover;
        }
      }
      &-text{
        padding-top: 48px;
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        h2{
          position:absolute;
          bottom: 18vh;
          @media screen and (max-width: 1199px) {
            font-size: 35px;
            bottom: 21vh;
          }
          @media screen and (max-width: 992px) {
            font-size: 30px;
            bottom: 155px;
          }
          @media screen and (max-width: 500px) {
            max-width: 314px;
            bottom: 148px;
          }
        }
      }
    }
    &-btn{
      position: absolute;
      bottom: 7vh;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 1500px) {
        bottom: 70px;
      }
      @media screen and (max-width: 1350px) {
        bottom: 60px;
      }
      @media screen and (max-width: 1250px) {
        bottom: 65px;
      }
      @media screen and (max-width: 992px) {
        bottom: 45px;
      }
      button{
        all: unset;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: 190px;
        height: 56px;
        border-radius: 10px;
        background: rgb(254,206,9);
        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
        color: black;
        font-family: 'Font Bold';
        font-size: 18px;
        border: none;
        outline: none;
        cursor: pointer;
        text-transform: uppercase;
        &:hover, &:focus{
          box-shadow: none;
          svg{
            color: black;
            path{
              stroke: black;
            }
          }
        }
        svg{
          width: 24px;
          height: 24px;
          padding: 0;
          margin: 0 0 10px 0;
        }
      }
    }
}
.shape {
  width: 100%;
  height: 85vh;
  max-height: 100vh;
  position: relative;
  @media screen and (max-width: 1600px) {
    max-height: 93vh;
  }
  @media screen and (max-width: 1450px) {
    max-height: 86vh;
  }
  @media screen and (max-width: 1350px) {
    max-height: 80vh;
  }
  @media screen and (max-width: 1199px) {
    max-height: 76vh;
  }
  @media screen and (max-width: 1100px) {
    max-height: 73vh;
  }
  @media screen and (max-width: 992px) {
    max-height: 678px;
  }
}

.shape::before {
  content: "";
  display: flex;
  width: 100%;
  height: 85vh;
  max-height: 100vh;
  background-color: var(--main-color);
  clip-path: polygon(0% 100%, 100% 80%, 100% 0%, 0% 0%);
  @media screen and (max-width: 1600px) {
    max-height: 93vh;
  }
  @media screen and (max-width: 1450px) {
    max-height: 86vh;
  }
  @media screen and (max-width: 1350px) {
    max-height: 80vh;
  }
  @media screen and (max-width: 1199px) {
    max-height: 76vh;
  }
  @media screen and (max-width: 1100px) {
    max-height: 73vh;
  }
  @media screen and (max-width: 992px) {
    max-height: 678px;
  }
}
</style>
<script>
export default {
  name: 'Banner',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    }
  },
  methods: {
    scrollToElement() {
      document.getElementById("prizes").scrollIntoView({ behavior: "smooth", block: "start" });
    },
  }
}
</script>